import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-21ecb605"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "detail"
};
const _hoisted_2 = {
  class: "detail-item"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "骑行记录申述单详情", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "用户", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "申述类型", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "申述时间", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "处理状态", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "申述内容", -1));
const _hoisted_9 = {
  class: "detail-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "机构名称", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "用户名称", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "开始时间", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "结束时间", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "骑行费用", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "已付费用", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "欠缴费用", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "骑行时长", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "骑行里程", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "支付状态", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "是否超运营停放", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "超运营停放调度费用", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "是否站外停放", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "站外停放调度费用", -1));
const _hoisted_24 = {
  key: 1,
  class: "file-images"
};
const _hoisted_25 = {
  class: "image-slot"
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "退款金额", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "变更后骑行费用", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "变更后超运营范围调度费", -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "变更后站外停放调度费", -1));
const _hoisted_31 = {
  key: 1
};
const _hoisted_32 = {
  style: {
    "text-align": "center",
    "margin-top": "10px"
  }
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "选择驳回到的步骤", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_icon_picture = _resolveComponent("icon-picture");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_image = _resolveComponent("el-image");
  const _component_bpmnDraw = _resolveComponent("bpmnDraw");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_image_viewer = _resolveComponent("el-image-viewer");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_descriptions, {
    column: 2,
    border: "",
    style: {
      "margin-top": "10px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_4]),
      default: _withCtx(() => {
        var _$data$data$customerP;
        return [_createTextVNode(" " + _toDisplayString($data.data.customerName) + " (" + _toDisplayString((_$data$data$customerP = $data.data.customerPhone) !== null && _$data$data$customerP !== void 0 ? _$data$data$customerP : '-') + ") ", 1)];
      }),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_5]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.data.recordRepresentationType), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_6]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.data.createTime), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_7]),
      default: _withCtx(() => [$data.data.status === '处理中' ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.data.status), 1)]),
        _: 1
      })) : $data.data.status === '已驳回' ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 1,
        type: "danger"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.data.status), 1)]),
        _: 1
      })) : $data.data.status === '已处理' ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 2,
        type: "success"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.data.status), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      span: 3
    }, {
      label: _withCtx(() => [_hoisted_8]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.data.representationDesc), 1)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_tabs, {
    modelValue: $data.activeName,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.activeName = $event),
    onTabChange: $options.handleTabChange,
    stretch: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "骑行记录",
      name: "parkRecord"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_descriptions, {
        column: 2,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_10]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.orgName), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_11]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.customerName), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_12]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.beginTime), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_13]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.endTime), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_14]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.rideFee), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_15]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.paidFee), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_16]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.oweFee), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: 3
        }, {
          label: _withCtx(() => [_hoisted_17]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.durations), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_18]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.mileage), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_19]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.payState), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_20]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.outFence === true ? "超出" : "否"), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_21]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.outFenceFee), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_22]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.nonPark === true ? "站外停放" : "否"), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_hoisted_23]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.parkRecord.nonParkFee), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_createTextVNode("骑行记录日志")]),
        _: 1
      }), _createVNode(_component_el_table, {
        data: $data.parkRecord.logs,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "类型",
          prop: "logType",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          label: "时间",
          prop: "logTime",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          label: "操作人",
          prop: "operatorName",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "remark",
          align: "center"
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "申述资料",
      name: "images"
    }, {
      default: _withCtx(() => [!$data.data.filePaths || $data.data.filePaths.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 0,
        description: "没有申述资料",
        "image-size": 80,
        style: {
          "--el-empty-padding": "0"
        }
      })) : (_openBlock(), _createElementBlock("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.data.filePaths, url => {
        return _openBlock(), _createBlock(_component_el_image, {
          key: url,
          src: url,
          "preview-src-list": [url],
          "initial-index": 0
        }, {
          error: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_icon_picture)]),
            _: 1
          })])]),
          _: 2
        }, 1032, ["src", "preview-src-list"]);
      }), 128))]))]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "审批流程",
      name: "flow"
    }, {
      default: _withCtx(() => [$data.data.flowDefinitionId ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_bpmnDraw, {
        ref: "bpmnDraw",
        style: {
          "height": "240px"
        }
      }, null, 512), !$data.firstCheck && $data.data.param ? (_openBlock(), _createBlock(_component_el_descriptions, {
        key: 0,
        column: 3,
        border: "",
        style: {
          "margin": "10px 0"
        }
      }, {
        default: _withCtx(() => [$data.data.param.refundFee ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
          key: 0
        }, {
          label: _withCtx(() => [_hoisted_27]),
          default: _withCtx(() => {
            var _$data$data$param$ref;
            return [_createTextVNode(" " + _toDisplayString((_$data$data$param$ref = $data.data.param.refundFee) !== null && _$data$data$param$ref !== void 0 ? _$data$data$param$ref : '-'), 1)];
          }),
          _: 1
        })) : _createCommentVNode("", true), $data.data.param.rideFee !== null ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
          key: 1
        }, {
          label: _withCtx(() => [_hoisted_28]),
          default: _withCtx(() => {
            var _$data$data$param$rid;
            return [_createTextVNode(" " + _toDisplayString((_$data$data$param$rid = $data.data.param.rideFee) !== null && _$data$data$param$rid !== void 0 ? _$data$data$param$rid : '-'), 1)];
          }),
          _: 1
        })) : _createCommentVNode("", true), $data.data.param.outFenceFee !== null ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
          key: 2
        }, {
          label: _withCtx(() => [_hoisted_29]),
          default: _withCtx(() => {
            var _$data$data$param$out;
            return [_createTextVNode(" " + _toDisplayString((_$data$data$param$out = $data.data.param.outFenceFee) !== null && _$data$data$param$out !== void 0 ? _$data$data$param$out : '-'), 1)];
          }),
          _: 1
        })) : _createCommentVNode("", true), $data.data.param.nonParkFee !== null ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
          key: 3
        }, {
          label: _withCtx(() => [_hoisted_30]),
          default: _withCtx(() => {
            var _$data$data$param$non;
            return [_createTextVNode(" " + _toDisplayString((_$data$data$param$non = $data.data.param.nonParkFee) !== null && _$data$data$param$non !== void 0 ? _$data$data$param$non : '-'), 1)];
          }),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })) : _createCommentVNode("", true), $data.assignee.indexOf(_ctx.userId) >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_el_form, {
        model: $data.processForm,
        rules: $data.processRules,
        ref: "processFormRef",
        "label-width": "100px"
      }, {
        default: _withCtx(() => [$data.firstCheck ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "修改数据",
          prop: "modify"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: $data.processForm.modify,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.processForm.modify = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), $data.processForm.modify ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "退款金额"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: $data.processForm.refundFee,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.processForm.refundFee = $event),
            step: 1,
            precision: 2,
            min: 0,
            max: $data.parkRecord.paidFee,
            placeholder: "请输入退款金额"
          }, null, 8, ["modelValue", "max"])]),
          _: 1
        })) : _createCommentVNode("", true), $data.processForm.modify ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 2,
          label: "骑行费用"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: $data.processForm.rideFee,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.processForm.rideFee = $event),
            step: 1,
            precision: 2,
            min: 0,
            max: $data.parkRecord.rideFee,
            placeholder: "请输入骑行费用"
          }, null, 8, ["modelValue", "max"])]),
          _: 1
        })) : _createCommentVNode("", true), $data.processForm.modify ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 3,
          label: "超运营范围调度费"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: $data.processForm.outFenceFee,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.processForm.outFenceFee = $event),
            step: 1,
            precision: 2,
            min: 0,
            max: $data.parkRecord.outFenceFee,
            placeholder: "请输入骑行费用"
          }, null, 8, ["modelValue", "max"])]),
          _: 1
        })) : _createCommentVNode("", true), $data.processForm.modify ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 4,
          label: "站外停放调度费"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: $data.processForm.nonParkFee,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.processForm.nonParkFee = $event),
            step: 1,
            precision: 2,
            min: 0,
            max: $data.parkRecord.nonParkFee,
            placeholder: "请输入骑行费用"
          }, null, 8, ["modelValue", "max"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "审核意见（公开）",
          prop: "message"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.processForm.message,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.processForm.message = $event),
            rows: 4,
            type: "textarea",
            placeholder: "请输入审核意见"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "内部意见",
          prop: "content"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.processForm.content,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.processForm.content = $event),
            rows: 4,
            type: "textarea",
            placeholder: "请输入内部意见"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_32, [_createVNode(_component_el_button, {
        type: "success",
        onClick: _cache[7] || (_cache[7] = $event => $options.doProcess('pass'))
      }, {
        default: _withCtx(() => [_createTextVNode("审核通过")]),
        _: 1
      }), $data.historyActivity.length === 1 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "danger",
        onClick: _cache[8] || (_cache[8] = $event => $options.doProcess('reject', $data.historyActivity[0]))
      }, {
        default: _withCtx(() => [_createTextVNode(" 驳回 ")]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_popover, {
        key: 1,
        modelValue: $data.toActivity,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.toActivity = $event),
        placement: "top"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[9] || (_cache[9] = $event => _ctx.visible = true)
        }, {
          default: _withCtx(() => [_createTextVNode("驳回")]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_33, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.historyActivity, activity => {
          return _openBlock(), _createElementBlock("div", {
            key: activity.activityId,
            style: {
              "margin-bottom": "5px"
            }
          }, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $event => $options.doProcess('reject', activity)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(activity.activityName), 1)]),
            _: 2
          }, 1032, ["onClick"])]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]))])])) : _createCommentVNode("", true)])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "没有流程信息",
        "image-size": 80,
        style: {
          "--el-empty-padding": "0"
        }
      }))]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "日志",
      name: "logs"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table, {
        data: $data.data.logs,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "logType",
          label: "类型",
          width: "90px",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "时间",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "userName",
          label: "处理人",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "messageContent",
          label: "处理意见",
          align: "center"
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "onTabChange"])]), $data.dialogVisible ? (_openBlock(), _createBlock(_component_el_image_viewer, {
    key: 0,
    "url-list": [$data.src],
    onClose: _cache[12] || (_cache[12] = $event => $data.dialogVisible = false)
  }, null, 8, ["url-list"])) : _createCommentVNode("", true)])), [[_directive_loading, $data.loading]]);
}